import { render, staticRenderFns } from "./FormNewReference.vue?vue&type=template&id=622d79e4&scoped=true"
import script from "./FormNewReference.vue?vue&type=script&lang=js"
export * from "./FormNewReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622d79e4",
  null
  
)

export default component.exports